import { useTab } from '@components/Tabs/Tabs'

interface TabBodyProps {
  children: React.ReactNode
  tabId: string
}

export function TabBody({ tabId, children }: TabBodyProps) {
  const { activeTab } = useTab()

  return activeTab === tabId ? <div>{children}</div> : null
}
